<template>
  <dv-full-screen-container>
    <div id="main">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div class="topTitleBox">
        <div class="dateTimeBox">
          <div class="dateTimeBox-after"></div>
          <span class="dateText">
            <dv-decoration-7 style="height: 30px">{{
              timeText
            }}</dv-decoration-7></span>
        </div>
        <dv-decoration-10 style="width: 33.33%; height: 10px; margin-top: 20px" />
        <div class="leftDecorate">
          <dv-decoration-3 style="width: 100%; height: 30px" />
        </div>
        <dv-decoration-8 :color="['#568aea', '#000000']"
                         style="width: 10%; height: 50px; margin-top: 25px" />
        <div class="title">
          <dv-decoration-5 :dur="2"
                           :color="['#568aea', '#568aea']"
                           style="width: 100%; height: 30px" /><span>利丰达可视化看板</span>
          <dv-decoration-6 :reverse="true"
                           :color="['#50e3c2', '#67a1e5']"
                           style="width: 250px; height: 10px" />
        </div>
        <dv-decoration-8 :reverse="true"
                         :color="['#568aea', '#000000']"
                         style="width: 10%; height: 50px; margin-top: 20px" />
        <dv-decoration-10 style="
            width: 33.33%;
            height: 10px;
            margin-top: 15px;
            transform: rotateY(180deg);
          " />
        <div class="xm-header__btn">
          <el-button @click="showMenu">显示菜单</el-button>
        </div>
      </div>
      <div class="content">
        <div class="contentTopBox">
          <div>
            <dv-border-box-1>
              <ICurrentTable title="库存现有量"
                             :tableData="iCurrentData"></ICurrentTable>
            </dv-border-box-1>
          </div>
          <div class="tankBox">
            <div class="tankRow"
                 v-for="(item, index) in tankData"
                 :key="`tankRow${index}`">
              <div class="tankItem"
                   v-for="(it, ix) in item"
                   :key="`tankItem${ix}`">
                <tank :tankData="it"></tank>
              </div>
            </div>
          </div>
        </div>
        <div class="contentBottomBox">
          <dv-border-box-8>
            <WarningTable title="预警"
                          :tableData="warningData"></WarningTable>
          </dv-border-box-8>
          <dv-border-box-10>
            <!-- <stacking-bar :chartData="stackingData"></stacking-bar> -->
            <in-out-chart :chartData="inOutData"></in-out-chart>
          </dv-border-box-10>
        </div>
      </div>
    </div>
  </dv-full-screen-container>
</template>

<script>
import moment from 'moment'
import InventoryBar1 from '../components/inventoryBar1'
import InventoryBar2 from '../components/inventoryBar2'
import InOutChart from '../components/inOutChart'
import StackingBar from '../components/stackingBar'
import WarningTable from '../components/warningTable' // categoryTable
import Tank from './tank'
import ICurrentTable from '../components/iCurrentTable'
// import watermark from '@/common/watermark'
import { mapActions } from 'vuex'

export default {
  name: 'lfdBoard',
  components: {
    InventoryBar1,
    InventoryBar2,
    InOutChart,
    WarningTable,
    StackingBar,
    Tank,
    ICurrentTable
  },
  data () {
    return {
      loading: true,
      timeText: '', // 时间
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      tankData: [
        // [
        //   {
        //     name: '罐A0001',
        //     material: '70道路沥青',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐A0002',
        //     material: '70道路沥青2',
        //     new: 1488,
        //     old: 2688,
        //     total: 3000,
        //     change: 1200
        //   },
        //   {
        //     name: '罐A0003',
        //     material: '70道路沥青3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐A0004',
        //     material: '70道路沥青4',
        //     new: 280,
        //     old: 260,
        //     total: 300,
        //     change: 20
        //   }
        // ],
        // [
        //   {
        //     name: '罐B0001',
        //     material: '92#汽油',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐B0002',
        //     material: '92#汽油2',
        //     new: 180,
        //     old: 180,
        //     total: 200,
        //     change: 0
        //   },
        //   {
        //     name: '罐B0003',
        //     material: '92#汽油3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐B0004',
        //     material: '92#汽油4',
        //     new: 2400,
        //     old: 2666,
        //     total: 5000,
        //     change: 266
        //   }
        // ],
        // [
        //   {
        //     name: '罐C0001',
        //     material: '70道路沥青',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐C0002',
        //     material: '70道路沥青2',
        //     new: 180,
        //     old: 180,
        //     total: 200,
        //     change: 0
        //   },
        //   {
        //     name: '罐C0003',
        //     material: '70道路沥青3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   }
        // ]
      ],
      stackingData: [
        {
          name: '成品油',
          data: new Array(12).fill(0)
        },
        {
          name: '碳材料',
          data: new Array(12).fill(0)
        },
        {
          name: '化工品',
          data: new Array(12).fill(0)
        },
        {
          name: '聚烯烃',
          data: new Array(12).fill(0)
        },
        {
          name: '沥青',
          data: new Array(12).fill(0)
        }
      ],
      inOutData: {
        xAxisData: [],
        monthTotal: new Array(moment().date()).fill(0),
        inQuantity: new Array(moment().date()).fill(0),
        outQuantity: new Array(moment().date()).fill(0),
        endingQuantityTotal: 0,
        inQuantityTotal: 0,
        outQuantityTotal: 0,
        openingQuantityTotal: 0
      },
      iCurrentData: [],
      warningData: []
    }
  },
  created () { },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    // watermark.show()
  },
  methods: {
    ...mapActions(['queryLFDBoardData']),
    timeFn () {
      // 获取时间
      setInterval(() => {
        const now = new Date()
        this.timeText = `${now.toLocaleString()} ${this.weekday[now.getDay()]}`
      }, 1000)
    },
    async init () {
      this.loading = true
      try {
        this.timeFn()
        // watermark.out()
        const result = await this.queryLFDBoardData({
          reservoirAreaCode: 'LFDK'
        })
        const { data } = result
        if (data) {
          const {
            itemTypeDtoList,
            oilTankDtoList,
            storageDayDtoList,
            totalDto,
            inventoryNumDtoList,
            inventoryForewarningDtoList
          } = data
          if (Array.isArray(inventoryForewarningDtoList) && inventoryForewarningDtoList.length > 0) {
            this.warningData = inventoryForewarningDtoList
          }
          if (Array.isArray(inventoryNumDtoList) && inventoryNumDtoList.length > 0) {
            this.iCurrentData = inventoryNumDtoList
          }
          if (Array.isArray(itemTypeDtoList) && itemTypeDtoList.length > 0) {
            itemTypeDtoList.forEach((item) => {
              const { month, quantity, type } = item
              const temp = this.stackingData.find((i) => i.name === type)
              temp.data.splice(month - 1, 1, quantity)
            })
          }
          if (Array.isArray(oilTankDtoList) && oilTankDtoList.length > 0) {
            const tankArr = oilTankDtoList.map((item) => {
              const {
                changeQuantity,
                endingQuantity,
                itemName,
                oilTankCode,
                openingQuantity,
                oilTankCapacity
              } = item
              return {
                name: oilTankCode,
                material: itemName,
                old: openingQuantity || 0,
                new: endingQuantity || 0,
                change: changeQuantity || 0,
                total: oilTankCapacity || 0
              }
            })
            this.convertTankData(tankArr)
          }
          if (
            Array.isArray(storageDayDtoList) &&
            storageDayDtoList.length > 0
          ) {
            storageDayDtoList.forEach((item) => {
              const { day, endingQuantity, inQuantity, outQuantity } = item
              this.inOutData.monthTotal.splice(day - 1, 1, endingQuantity)
              this.inOutData.inQuantity.splice(day - 1, 1, inQuantity)
              this.inOutData.outQuantity.splice(day - 1, 1, outQuantity)
            })
          }
          const { endingQuantityTotal, inQuantityTotal, outQuantityTotal, openingQuantityTotal } =
            totalDto || {}
          this.inOutData.endingQuantityTotal = endingQuantityTotal
          this.inOutData.inQuantityTotal = inQuantityTotal
          this.inOutData.outQuantityTotal = outQuantityTotal
          this.inOutData.openingQuantityTotal = openingQuantityTotal
          this.inOutData.xAxisData = this.getInOutXAxis()
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    convertTankData (data) {
      let tankArr = []
      for (let i = 0; i < data.length; i += 4) {
        tankArr.push(data.slice(i, i + 4))
      }
      this.tankData = tankArr
    },
    showMenu () {
      this.$router.replace({ path: '/virtual/lfdBoard' })
    },
    getInOutXAxis () {
      let startDate = moment().startOf('month').format('MM/DD') // 当前月的第一天
      let currentDate = moment().subtract(1, 'days').format('MM/DD') // 前一天
      let dateArray = []
      // 循环从第一天到前一天
      for (
        let m = moment(startDate);
        m.isSameOrBefore(currentDate);
        m.add(1, 'days')
      ) {
        dateArray.push(m.format('MM/DD'))
      }
      return dateArray
    }
  }
}
</script>

<style scoped lang="scss">
#main {
  width: 100%;
  height: 100%;
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  ::v-deep .loading-tip {
    font-size: 23px !important;
    color: aqua;
    font-weight: bold;
  }
  .topTitleBox {
    width: 100%;
    height: 6%;
    display: flex;
    position: relative;
    .leftDecorate {
      position: absolute;
      left: 7%;
      top: 32px;
    }
    .dateTimeBox {
      position: absolute;
      right: 7%;
      top: 36%;
      color: #06f1ef;
      font-size: 20px;
      background-color: rgb(15, 19, 37);
      width: 20.33%;
      height: 50px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      -webkit-transform: skewX(-45deg);
      transform: skewX(-45deg);
      .dateText {
        display: inline-block;
        transform: skewX(45deg);
      }
      .dateTimeBox-after {
        position: absolute;
        right: -25px;
        top: 0;
        height: 50px;
        width: 50px;
        background-color: rgb(15, 19, 37);
        -webkit-transform: skewX(45deg);
        transform: skewX(45deg);
      }
    }
    .title {
      width: 500px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 25px;
      color: white;
    }
    .xm-header__btn {
      position: absolute;
      right: 2%;
      top: 28px;
    }
  }
  .content {
    width: 100%;
    height: 94%;
    .contentTopBox {
      height: 50%;
      padding: 10px;
      display: grid;
      grid-template-columns: 2fr 3fr;
      .tankBox {
        padding: 10px;
        height: 100%;
        overflow: auto;
        background-color: transparent;
        border-radius: 5px;
        /* 隐藏默认的滚动条样式 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        .tankRow {
          display: flex;
          height: 50%;
          .tankItem {
            width: 25%;
            border: 1px dashed gray;
          }
        }
      }
      .tankBox::-webkit-scrollbar {
        display: none; /* Chrome, Safari, and Opera */
      }
    }
    .contentBottomBox {
      height: 50%;
      display: grid;
      padding: 10px;
      grid-template-columns: 2fr 3fr;
    }
  }
}
</style>
